// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"127":"85510f8c","307":"d299a1bf","314":"ac075cf9","745":"c81228d2"}[chunkId] + ".css";
};